import cartaDerechoImagen from "../../assets/img/carta-de-derechos.png"
import codigoConductaImagen from "../../assets/img/codigo-de-conducta.png"
import codigoVestimentaImagen from "../../assets/img/codigo-de-vestimenta.png"
import culturaImagen from "../../assets/img/colaboracion.png"
import legalesImagen from "../../assets/img/cumplimiento.png"
import procesosPoliticaImagen from "../../assets/img/politica.png"
import protocolosServivioImagen from "../../assets/img/soporte-tecnico.png"
import nom035Imagen from "../../assets/img/validacion.png"

import {Col, Container, Row} from "react-bootstrap";
import {useEffect, useState} from "react";
import {ShortcutCard} from "../shortcuts/ShortcutCard";

export const LineamientosNew = () => {
    const [setError] = useState("");

    const shortcuts = [
        {
            title: "Sé Nice",
            description: "Sé Nice",
            imgUrl: cartaDerechoImagen,
            url: "/lineamientos/se-nice",
            backgroundColor: "rgba(102,185,179,0.42)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
        {
            title: "Código de vestimenta y manual de imagen",
            description: "Código de vestimenta y manual de imagen",
            imgUrl: codigoVestimentaImagen,
            url: "/lineamientos/codigo-vestimenta",
            backgroundColor: "rgba(211,112,46,0.42)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
        {
            title: "Cultura",
            description: "Cultura empresarial",
            imgUrl: culturaImagen,
            url: "/lineamientos/cultura",
            backgroundColor: "rgba(241,207,73,0.42)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
        {
            title: "NOM 035",
            description: "NOM 035",
            imgUrl: nom035Imagen,
            url: "/lineamientos/nom-035",
            backgroundColor: "rgba(188,43,108,0.42)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
        {
            title: "Normas de conducta",
            description: "Normas de conducta",
            imgUrl: codigoConductaImagen,
            url: "/lineamientos/normas-conducta",
            backgroundColor: "rgba(102,185,179,0.42)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
        {
            title: "Capacitaciones",
            description: "Capacitacion",
            imgUrl: legalesImagen,
            url: "/lineamientos/capacitacion",
            backgroundColor: "rgba(241,207,73,0.37)", // Color personalizado
            textColor: "hsla(0, 0%, 100%, 1.00)",
        },
        {
            title: "Procesos y politicas",
            description: "Procesos y politicas",
            imgUrl: legalesImagen,
            url: "/lineamientos/procesos-politicas",
            backgroundColor: "rgba(211,112,46,0.47)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
        {
            title: "Protocolos de servicios",
            description: "Protocolo de servicios",
            imgUrl: protocolosServivioImagen,
            url: "/lineamientos/protocolos-servicio",
            backgroundColor: "rgba(188,43,108,0.42)", // Color personalizado
            textColor: "rgb(255, 255, 255)",
        },
    ];


    return (
        <section className="shortcut-lineamientos" id="shortcuts-de-lineamientos">
            <Container>
                <div className={"banner-transparente"}>
                    <h1 className="banner-title">Lineamientos</h1>
                    <p className="banner-description">
                        Conoce los lineamientos de nuestra empresa: principios, normas y prácticas diseñadas para guiar
                        nuestro trabajo con integridad, profesionalismo y compromiso.
                    </p>
                </div>
                <Row className={"justify-content-center pb-5"}>
                    {shortcuts.map((shortcut, index) => (
                        <Col key={index} xs={6} sm={3} md={3} lg={3}>
                            <ShortcutCard {...shortcut} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};